import api from '../../services/report';
export default function (helper) {
/**
 * Generated store module
 */
helper.setApi(api);
const types = helper.types('report');
const state = helper.state();
const getters = helper.getters();
const actions = helper.actions({
  deliverable(context, params) {
    helper.log().info("[Store: Report]: Get Deliverable Report", params);
    return helper
      .api()
      .deliverable(params)
      .then((response) => {
        helper
          .log()
          .info(`[Store: Report]: Got Deliverable Report`, response);
        return response.data.data;
      })
      .catch((error) => {
        helper
          .log()
          .info(`[Store: Report]: Error Getting Deliverable Report`, error);
        throw error;
      });
  }
}, 'Report');
const mutations = helper.mutations({}, types, state);

return {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };
}